import React, { useMemo } from 'react';

import { ArtistDrop } from '@components/Feed/Activities/Types/ArtistDrop';
import { LikedPlaylist } from '@components/Feed/Activities/Types/Liked/LikedPlaylist';
import { NewLikedReleases } from '@components/Feed/Activities/Types/Liked/LikedReleases';
import { PlaylistCreated } from '@components/Feed/Activities/Types/PlaylistCreated';
import { FeedActivityTypePost } from '@components/Feed/Activities/Types/Post';
import { ReleaseCollectedByMany } from '@components/Feed/Activities/Types/ReleaseCollectedByMany';
import { ReleasesAddedToPlaylist } from '@components/Feed/Activities/Types/ReleasesAddedToPlaylist';
import { UserCollectedManySongs } from '@components/Feed/Activities/Types/UserCollectedManySongs';
import { ActivityFeedState, type ActivityGroupWithDivider } from './store';

export const FeedActivityGroup = ({
  item,
  index,
}: {
  index: number;
  item: ActivityGroupWithDivider;
}) => {
  const information = item.information;
  const timeStamp = item.latestActivityOccurenceAt;

  const content = useMemo(() => {
    switch (information.__typename) {
      case 'SongCollectedByManyAggregate':
        return (
          <ReleaseCollectedByMany
            key={item.id}
            activityId={item.id}
            activityFrag={information}
            timeStamp={timeStamp}
          />
        );
      case 'ReleaseDroppedAggregate':
        return (
          <ArtistDrop
            key={item.id}
            releaseFrag={information.release}
            postActionsFrag={information.post}
            timeStamp={timeStamp}
          />
        );
      case 'UserCollectedManySongsAggregate':
        return (
          <UserCollectedManySongs
            key={item.id}
            activityFrag={information}
            postActionsFrag={information.post}
            timeStamp={item.latestActivityOccurenceAt}
          />
        );

      case 'ShelfCreatedAggregate':
        return (
          <PlaylistCreated
            key={item.id}
            activityFrag={information}
            timeStamp={item.latestActivityOccurenceAt}
          />
        );

      case 'ReleasesAddedToShelfAggregate':
        return (
          <ReleasesAddedToPlaylist
            key={item.id}
            activityFrag={information}
            timeStamp={item.latestActivityOccurenceAt}
          />
        );

      case 'UserLikedSongsAggregate':
        return (
          <NewLikedReleases
            key={item.id}
            activityFrag={information}
            timeStamp={item.latestActivityOccurenceAt}
          />
        );

      case 'UserLikedPlaylistAggregate':
        return (
          <LikedPlaylist
            key={item.id}
            activityFrag={information}
            timeStamp={item.latestActivityOccurenceAt}
          />
        );

      case 'UserCreatedPostAggregate':
        return (
          <FeedActivityTypePost key={item.id} activityFrag={information} timeStamp={timeStamp} />
        );

      default:
        return null;
    }
  }, [item, information, timeStamp]);

  return (
    <div
      className="pb-7"
      onClick={() => {
        ActivityFeedState.scrollIndex = index;
      }}
    >
      {content}
    </div>
  );
};
